import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

// LiquidacionWeb.Tipo type definition
export type LiquidacionWebTipo =
  | 'Importación'
  | 'Exportación'
  | 'Reparación'
  | 'VacíoExportación'
  | 'VacíoImportación'
  | 'Proforma'
  | 'VentaContenedor'
  | 'DEPO20'
  | 'Reintegro';

type ApiResponse = {
  exception: null;
  state: number;
  value: number;
  isFaulted: boolean;
  isSuccess: boolean;
};

export type SaveSettlementValidated = {
  oid: number;
  consumidorFinal: boolean;
  tipo: LiquidacionWebTipo;
  observaciones: string;
  cliente: string;
  rutCliente: string;
  fechaInicio: string | Date;
  despachante: string;
  rutDespachante: string;
  esProformaWeb?: boolean;
};

export const saveAndAddSettlement = async (
  query: SaveSettlementValidated
): Promise<ApiResponse['value']> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.saveAndAddSettlement,
      query
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
